import { Drawer } from "antd";
import { useTranslation } from "react-i18next";
import { useAppContext } from "utils/context";
import { useState } from "react";
import { useDispatch } from "react-redux";

import { postVoucherRedeem } from "containers/services/services";
import { setVoucher } from "store/voucher/action";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ArrowLeft } from "assets/icons/arrow-left-primary.svg";
import VoucherForm from "./form";

const VoucherBankDrawer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { instance } = useAppContext();

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const handleShowDrawer = () => setOpen(true);
  const handleCloseDrawer = () => setOpen(false);

  const handleFinishVoucher = async (data) => {
    setLoading(true);
    const { data: redeemData, error: errorRedeem } = await postVoucherRedeem(
      instance,
      data
    );

    if (redeemData) {
      dispatch(setVoucher(redeemData));
      navigate("/voucher/receipt");
    }
    if (errorRedeem?.detail) setError(errorRedeem?.detail);
    setLoading(false);
  };

  return (
    <>
      <div
        className="flex justify-between items-center p-4 rounded-lg border border-gray--6 text-gray-4 mb-5 cursor-pointer"
        onClick={handleShowDrawer}
      >
        <div className="flex gap-2 justify-between items-center">
          <img
            src={"https://cdn.firouzeh.com/public/voucher-ticket.png"}
            alt={t("voucher.title")}
            className="w-14 h-auto m-auto table"
          />
          <div className="body-16px-demibold text-black">کد فیروزه‌ای دارم</div>
        </div>
        <ArrowLeft className="[&>path]:fill-gray-4 w-5 h-5 " />
      </div>
      <Drawer
        className="limit-drawer"
        destroyOnClose={true}
        key="bottom"
        open={open}
        title={t("voucher.title")}
        placement={window.innerWidth < 768 ? "bottom" : "left"}
        onClose={handleCloseDrawer}
      >
        <div className="flex flex-col gap-5 relative h-full pb-20">
          <VoucherForm
            error={error}
            loading={loading}
            onFinish={handleFinishVoucher}
          />
        </div>
      </Drawer>
    </>
  );
};
export default VoucherBankDrawer;
